import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { theme } from '@garnish/constants';
import { LoadingPlaceholder } from '@garnish/core';

export const SierraLoadingIndicator = () => {
  const { top } = useSafeAreaInsets();
  const headerHeight = Platform.select({
    android: top + HEADER_HEIGHT, // android needs this extra top inset due to its modal presentation style.
    default: HEADER_HEIGHT,
  });

  return (
    <View style={styles.loadingContainer}>
      <LoadingPlaceholder borderRadius={0} rows={1} rowHeight={headerHeight} />

      <View style={styles.content}>
        <LoadingPlaceholder rows={1} rowHeight={30} />
        <LoadingPlaceholder rows={1} rowHeight={50} />
        <LoadingPlaceholder rows={1} rowHeight={30} />
        <LoadingPlaceholder rows={1} rowHeight={70} />
        <LoadingPlaceholder rows={1} rowHeight={40} />
      </View>

      <LoadingPlaceholder borderRadius={0} rows={1} rowHeight={60} />
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const HEADER_HEIGHT = 60;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  loadingContainer: {
    ...StyleSheet.absoluteFill,
    backgroundColor: theme.colors.WHITE,
    justifyContent: 'space-between',
    gap: theme.spacing['1'],
  },
  content: {
    marginTop: 'auto',
    padding: theme.spacing['2'],
    gap: theme.spacing['2'],
    justifyContent: 'space-between',
  },
});
